module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.roles && _vm.roles.indexOf('Student') > -1 &&
    _vm.localStorage.privacyPolicyAccepted.toString() !== 'true') ? _c('div', {
    staticClass: "privacy-policy"
  }, [_c('div', {
    staticClass: "privacy-text"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.acceptPrivacy()
      }
    }
  }, [_vm._v("I Agree")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("GDPR Regulations / Privacy Policy")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Welcome Think Tank friends! This is our privacy policy, it sets out how we handle your personal information if you are an employee, student, instructor, supervisor or director in our school, whether it be online or campus. We also collect some information about people that visit our site or sign up for our email lists.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Type of Personal Information we Collect")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We collect certain personal information about visitors and users of our sites. The most common type of information that we collect are: user names, member names, email addresses, IP addresses, other contact details, survey responses, email addresses, physical addresses, phone numbers, payment history and information, transactional details, educational history, demo reels and artistic projects completed while attending, tax information, support queries, forum comments, communication history, web analytics. We also collect personal information from applications, and job applications.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How we Collect this Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We collect this information directly when you provide it to us, automatically as you navigate sites, through email campaigns and sometimes social media activity on our pages. We collect personal information when you apply to the school and during your educational experience here. For contractors and employees, we collect the necessary information required for employment and any payment history. If you fill out a survey, subscribe to a newsletter, email list, enter a contest or send us a communication, information is also obtained.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Personal Information that we Collect about you from Others")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Although we generally collect information about you directly, sometimes your information can be obtained from a third party for marketing reason. Types of third party providers would be; affiliates, external email lists, word of mouth through industry contacts, payment platforms, fairs and studio tours.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How we use your Personal Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We will use your personal information to:")])]), _vm._v(" "), _c('ol', {
    staticClass: "c6 lst-kix_list_1-0 start",
    attrs: {
      "start": "1"
    }
  }, [_c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Fulfil a contract")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Facilitate and process transactions")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("In our student portal for admin and tracking purposes")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Send you relevant communications about the program or updates ")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Communicate amongst the students and alumni, employees and contractors")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Issue certificates for graduation")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Mail any relevant information")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("For marketing material (demo reels and demographics)")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Submit to governing bodies to ensure we are keeping up with regulations and aid students with government processes (PTIB, Student Loans, Immigration Services etc.)")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Obtain analytic information for site and program")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Managing relationship with you")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Improving our product and services")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Processing job applications and contracts")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Software licensing")])]), _vm._v(" "), _c('li', {
    staticClass: "c0 c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Purposes which are required by law and responding to government requests")])])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Where you Give us Consent")])]), _vm._v(" "), _c('ol', {
    staticClass: "c6 lst-kix_list_2-0 start",
    attrs: {
      "start": "1"
    }
  }, [_c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Providing you with marketing information about products and services which we feel you would be interested in")])]), _vm._v(" "), _c('li', {
    staticClass: "c0 c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Customizing our services and websites, like advertising that appears on our site – where this involves the use of cookies or similar technologies in order to provide a more personalized experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("We will Disclose your Information to the Following Recipients")])]), _vm._v(" "), _c('ol', {
    staticClass: "c6 lst-kix_list_3-0 start",
    attrs: {
      "start": "1"
    }
  }, [_c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Authors of any items or services made available to you (mostly software licenses) so they can facilitate support and license validation")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Our professional advisors, temporary contractors, contracted and employed instructors and all Think Tank staff, fellow students and alumni.")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Recipients that are required by law to do so")])]), _vm._v(" "), _c('li', {
    staticClass: "c0 c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("A purchaser or prospective purchaser of all or parts of the business and their professional advisors")])])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Where we Transfer and Store your Personal Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We are based in Canada so your personal information with be processed in Canada and potentially globally provided we expand and create satellite schools. Some of the recipients of this information are based outside of Canada. We only disclose information on the basis of your consent to this policy. In order to protect your information, we take care when possible to work with employees, contractors and service providers who we believe maintain an acceptable standard of data security compliance.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How we Keep your Information Secure")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We store personal information on secure servers that are managed by us or service providers and occasionally hardcopy files that are kept in a secure location (currently only in Canada but may change with incorporation of satellite schools). ")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How you can Access your Personal Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', [_vm._v("You can access your personal information by logging into your student Portal (students), or you can make a request to access the personal information that we have stored about you and to request corrections of any errors of the data. You can also close your account with us at any time upon request. Please email ")]), _c('span', {
    staticClass: "c4"
  }, [_c('a', {
    staticClass: "c7",
    attrs: {
      "href": "mailto:info@tttc.ca"
    }
  }, [_vm._v("info@tttc.ca")])]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" to initiate any requests regarding your personal data.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Marketing Choices Regarding your Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Where we have your consent to do so (if you have subscribed to an email list or have indicated you are interested in receiving communications), we send you marketing communications by email about products and services that we feel may be of interest to you. You can opt-out of these by unsubscribing. You also have a choice about cookies (below). By modifying your browser preferences, you have the choice to: accept all cookies, to be notified when cookies are set, or to reject all cookies. If you choose to reject the cookies, some parts of our site might not function properly for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Cookies!!! Yum Yum.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("When you visit our sites and social media pages, there is certain information that is recorded:")])]), _vm._v(" "), _c('ul', {
    staticClass: "c6 lst-kix_list_4-0 start"
  }, [_c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Your IP address and proxy server IP")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Domain name you requested")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Date and time of your visit")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Length of your session")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Pages you have accessed / clicks")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Number of times you have accessed our site")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("The file URL")])]), _vm._v(" "), _c('li', {
    staticClass: "c3"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("The website which referred you to our site")])]), _vm._v(" "), _c('li', {
    staticClass: "c0 c8"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("The operating system that your computer uses")])])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Occasionally we will use third party advertising companies to serve ads based on your prior visits.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Please check out this page for more information on cookies and how to change your browser settings:")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_c('a', {
    attrs: {
      "href": "http://web.archive.org/web/20130326235146"
    }
  }, [_vm._v("http://web.archive.org/web/20130326235146")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.theeucookielaw.com"
    }
  }, [_vm._v("http://www.theeucookielaw.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Information and Children")])]), _vm._v(" "), _c('p', {
    staticClass: "c0",
    attrs: {
      "id": "h.gjdgxs"
    }
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Our sites are not suitable for children under the age of 16, so if you are 16 we ask that you do not use our site or give us your personal information. If you are between the ages of 16-18 you can browse our sites but in order to register you must have the permission of a parent or guardian.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Information you Make Public or Give to Others")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("If you make your personal information available to other people, we can’t control or accept responsibility for the way they will use or manage that data. There are lots of ways that you can find yourself providing information to other people, like when you post a public message on a forum thread, share information via social media, or make contact with another user (such as a third party Author) whether via our Sites or directly via email. Before making your information publicly available or giving your information to anyone else, think carefully. If giving information to another user via our Sites, ask them how they will handle your information. If you’re sharing information via another website, check the privacy policy for that site to understand its information management practices as this privacy policy will not apply.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How Long we Keep your Information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', [_vm._v("We retain your personal information as long as necessary to provide the service to you and others, keep educational records and to comply with our legal obligations. If you no longer want us to use your information or provide you with services, please make a request to ")]), _c('span', {
    staticClass: "c4"
  }, [_c('a', {
    staticClass: "c7",
    attrs: {
      "href": "mailto:info@tttc.ca"
    }
  }, [_vm._v("info@tttc.ca")])]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" and we will close your account and stop providing you with service, please see policies and contracts on more about contractual obligations for your education. Please note that if you request the erasure of your personal information we will retain information from deleted accounts as necessary for our legitimate business interests, to comply with the law, prevent fraud, collect fees, resolve disputes, troubleshoot problems, assist with investigations, enforce the terms of service and take other actions permitted by law. The information we retain will be handled in accordance with this Privacy Policy.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("Updates on our Policy")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("We will update this policy from time to time to make sure we stay up-to-date with the latest legal requirements and any changes to our practises. If we do make a change, you will be notified of changes where required. ")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("European Visitors")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("For the purposes of the GDPR we are a “data controller” of your information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How you can access your personal information")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("You are also entitled to ask us to port your personal information (i.e. to transfer in a structured, commonly used and machine-readable format, to you), to erase it, or restrict its processing. You also have rights to object to some processing that is based on our legitimate interests, such as profiling that we perform for the purposes of direct marketing, and, where we have asked for your consent to process your data, to withdraw this consent as more fully described below.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("These rights are limited in some situations – for example, we can demonstrate that we have a legal requirement to process your personal information. In some instances, this means that we may retain some data even if you withdraw your consent.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("Where we require your personal information to comply with legal or contractual obligations, then provision of such data is mandatory: if such data is not provided, then we will not be able to manage our contractual relationship with you, or to meet obligations placed on us. In all other cases, provision of requested personal information is optional.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c1"
  }, [_vm._v("If you have unresolved concerns you also have the right to complain to data protection authorities. The relevant data protection authority will be the data protection authority of the country: (i) of your habitual residence; (ii) of your place of work; or (iii) in which you consider the alleged infringement has occurred.")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("How you can Contact Us")])]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', [_vm._v("Please email ")]), _c('span', {
    staticClass: "c4"
  }, [_c('a', {
    staticClass: "c7",
    attrs: {
      "href": "mailto:info@tttc.ca"
    }
  }, [_vm._v("info@tttc.ca")])]), _c('span', {
    staticClass: "c1"
  }, [_vm._v(" if you have any questions or concerns and an employee will get back to you as soon as possible. ")])]), _vm._v(" "), _c('p', {
    staticClass: "c0 c2"
  }, [_c('span', {
    staticClass: "c5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c0 c2"
  }, [_c('span', {
    staticClass: "c5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "c0"
  }, [_c('span', {
    staticClass: "c5"
  }, [_vm._v("This policy was last updated May 23, 2018.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-568b4fee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Privacy.vue
// module id = 2050
// module chunks = 2